import React, { memo, ReactNode } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { SupportContext, useSupportProvider } from './SupportContext';

interface Props {
  children: ReactNode;
}

function SupportProviderContainer({ children }: Props) {
  const value = useSupportProvider();

  return <SupportContext.Provider value={value}>{children}</SupportContext.Provider>;
}

const SupportProviderMemo = memo(SupportProviderContainer, areEqual);

export { SupportProviderMemo as SupportProvider };
